export const DEFAULT_TEXT = 'Login';